<template>
  <div class="gl-input-search-wrapper">
    <div>
      <gl-button
        class="button"
        :class="{ 'input-visible': inputVisible }"
        icon-button
        @click="toggleInput"
        ><gl-icon-search
      /></gl-button>
    </div>
    <div class="field-container" :style="fieldContainerStyles">
      <input
        class="input is-rounded"
        type="text"
        @input="$emit('update:value', $event.target.value)"
        :placeholder="placeHolder"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * テキスト入力欄のPlace Holder
     */
    placeHolder: {
      type: String,
    },
    /**
     * 入力テキスト
     */
    value: {
      type: String,
    },
    /**
     * テキスト入力欄の横幅
     */
    width: {
      type: Number,
      default: 250,
    },
  },
  data() {
    return {
      /**
       * テキスト入力欄の表示非表示
       */
      inputVisible: false,
    }
  },
  computed: {
    fieldContainerStyles() {
      return {
        width: `${this.inputVisible ? this.width : 0}px`,
      }
    },
  },
  methods: {
    toggleInput() {
      if (this.inputVisible) {
        this.$emit('update:value', '')
      }
      this.inputVisible = !this.inputVisible
    },
  },
}
</script>

<style lang="scss" scoped>
.gl-input-search-wrapper {
  display: flex;
}

.button {
  margin-left: 0;
  margin-right: 0;
}

.field-container {
  overflow: hidden;
  transition: width 0.2s ease-in-out;
  display: flex;
  align-items: center;
}

.input-visible {
  transform: rotate(440deg);
}
</style>
